import Actions from 'actions';

const initialState = Object.freeze([]);

function bookings(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_BOOKINGS_SUCCESS:
      return action.data;
    case Actions.SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}

export default bookings;
